export const onTouchStart = ({ onStart, onMove }) => ({
    currentTarget,
    touches: [touch, multi],
}) => {
    if (multi) {
        return;
    }

    let abortLongTouch;

    const touchMoveCanceler = event => {
        const {
            touches: [{ clientX, clientY }, multi],
        } = event;
        if (
            multi ||
            Math.abs(clientX - touch.clientX) > 10 ||
            Math.abs(clientY - touch.clientY) > 10
        ) {
            clearTimeout(captureTimeout);
            abortLongTouch();
        }
    };

    const captureTimeout = setTimeout(() => {
        onStart(touch);
        navigator && navigator.vibrate && navigator.vibrate(75);
        window.removeEventListener('touchend', abortLongTouch);
        currentTarget.removeEventListener('touchmove', touchMoveCanceler);
        currentTarget.addEventListener('touchmove', onMove);
        window.addEventListener('touchend', endListener);
    }, 1000);

    abortLongTouch = () => {
        clearTimeout(captureTimeout);
        window.removeEventListener('touchend', abortLongTouch);
        currentTarget.removeEventListener('touchmove', touchMoveCanceler);
    };

    const endListener = () => {
        clearTimeout(captureTimeout);
        window.removeEventListener('touchend', endListener);
        currentTarget.removeEventListener('touchmove', onMove);
    };

    window.addEventListener('touchend', abortLongTouch);
    currentTarget.addEventListener('touchmove', touchMoveCanceler);
};



// WEBPACK FOOTER //
// ./src/utils/longTouch.js